class config {
  url: string
  data: Record<string, unknown>

  constructor(backend: string) {
    if (process?.env?.NODE_ENV === "development") {
      this.url = `${backend}/assets/assets/conf/config.json`
    } else {
      this.url = `${backend}/assets/conf/config.json`
    }
  }

  async load() {
    const response = await fetch(this.url)
    this.data = await response.json()
  }

  get(key: string) {
    return this.data[key]
  }
}

export const Config = new config(window.location.origin)
